import { anchorClass } from './channel'

const CreateContent = () => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <a href="/upload" className={anchorClass}>
                Upload
            </a>
            <div className="h-8 w-0 border-l-2 border-white opacity-30" />
            <a href="/create" className={anchorClass}>
                Create
            </a>
        </div>
    )
}

export default CreateContent
